import { USER_STATUS } from '../api/ws.types';

export const updateLastMessage = (chats, message) => {
  if (!chats || !message) return chats;
  const idx = chats.findIndex((chat) => chat?.id === message.chat_id);
  if (idx === -1) return chats;
  const next = [...chats];
  next[idx] = { ...next[idx], last_message: { ...message } };
  return next;
};

export const markChatAsRead = (chats, chatId, messageId) => {
  if (!chats) return chats;
  const idx = chats.findIndex(
    (chat) => chat.id === chatId && chat.last_message?.id === messageId
  );
  if (idx === -1) return chats;
  const next = [...chats];
  next[idx] = {
    ...next[idx],
    last_message: { ...next[idx].last_message, is_read: true },
  };
  return next;
};

export const updateParticipantStatus = (chats, userId, status) => {
  if (!chats) return chats;
  const isOnline = status === USER_STATUS.ONLINE;
  let hasChanges = false;
  const next = chats.map((chat) => {
    const participant = chat.participants?.find((p) => p.id === userId);
    if (!participant) return chat;
    if (participant.online === isOnline) return chat;
    const nextParticipants = chat.participants.map((p) =>
      p.id === userId ? { ...p, online: isOnline } : p
    );
    hasChanges = true;
    return { ...chat, participants: nextParticipants };
  });
  return hasChanges ? next : chats;
};

export const sortChatsByLastMessage = (chats) => {
  if (!chats || chats.length <= 1) return chats || [];
  return [...chats].sort((a, b) => {
    const ta = a.last_message?.timestamp || 0;
    const tb = b.last_message?.timestamp || 0;
    return tb - ta;
  });
};

export const getChatByParticipantId = (chats, userId) => {
  if (!chats || !userId) return null;
  return chats.find((chat) => chat.participants?.[0]?.id === userId) || null;
};
